import React from 'react';
import './SessionStats.css';

export interface SessionStatItem {
  /** Unique key for the stat */
  key: string;
  /** Display label */
  label: string;
  /** Numeric value */
  value: number;
  /** Rating category for color coding (optional) */
  variant?: 'default' | 'hard' | 'medium' | 'easy' | 'skip' | 'new';
}

export interface SessionStatsProps {
  /** Title for the stats section */
  title?: string;
  /** Array of stat items to display */
  stats: SessionStatItem[];
  /** Additional CSS class */
  className?: string;
}

/**
 * Session statistics display component.
 * Shows progress breakdown with color-coded items based on rating difficulty.
 */
export const SessionStats: React.FC<SessionStatsProps> = ({
  title = 'Your Progress',
  stats,
  className = '',
}) => {
  return (
    <div className={`stc-session-stats ${className}`}>
      {title && <h3 className="stc-session-stats__title">{title}</h3>}
      <div className="stc-session-stats__grid">
        {stats.map(stat => (
          <div
            key={stat.key}
            className={`stc-session-stats__item stc-session-stats__item--${stat.variant || 'default'}`}
          >
            <div className="stc-session-stats__value">{stat.value}</div>
            <div className="stc-session-stats__label">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
